import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/products')({
    component: AdminProducts,
})

function AdminProducts() {
    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-3xl font-bold">Products</h1>
                <p className="text-muted-foreground mt-2">Manage your product catalog</p>
            </div>
            <div className="rounded-lg border bg-card p-6">
                <p className="text-sm text-muted-foreground">Product management interface will be displayed here</p>
            </div>
        </div>
    )
}
